/* Pehro editorial storefront behaviour. Vanilla, no dependencies. Every block
   is a no-op when its markup is absent, so the file loads once, globally. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- phone menu, a full screen view ---------- */
  function drawer() {
    var btn = document.querySelector('[data-drawer]');
    var panel = document.querySelector('[data-drawer-panel]');
    if (!btn || !panel) return;
    function set(open) {
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('mnav-open', open);
      if (open) panel.scrollTop = 0;
    }
    btn.addEventListener('click', function () { set(!panel.classList.contains('is-open')); });
    panel.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { set(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- product: two selects drive one variant id ---------- */
  function product() {
    document.querySelectorAll('[data-pd-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-pd-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-pd-variant-id]');
      var addBtn = root.querySelector('[data-pd-add]');
      var priceEl = root.querySelector('[data-pd-price]');

      /* The price element is server rendered and may have been rewritten by the
         currency app into the visitor's own currency. Touch it only when the
         chosen variant actually costs something different, and then put back
         Shopify's own money markup (class=money) so the app can convert that
         too. Formatting a price here in the shop currency is the last resort. */
      var shownPrice = priceEl ? parseInt(priceEl.getAttribute('data-pd-price'), 10) : null;
      var moneyMap = {};
      var moneyEl = root.querySelector('[data-pd-money]');
      if (moneyEl) { try { moneyMap = JSON.parse(moneyEl.textContent); } catch (e) {} }
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-pd-option]'));
      var fmt = root.getAttribute('data-money') || '${{amount}}';

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/, n)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
          .replace(/<[^>]+>/g, '');
      }

      function find() {
        var want = selects.map(function (s) { return s.value; });
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < want.length; j++) {
            if (variants[i].o[j] !== want[j]) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      }

      /* Shopify hands the theme at most 250 variants. Products with more
         (37 colours x 7 sizes = 259) keep the rest on the server, so a
         combination missing from the list is looked up by its option value
         ids through the Section Rendering API before it is called unavailable. */
      var total = parseInt(root.getAttribute('data-variant-total'), 10) || variants.length;
      var seq = 0;
      function none() {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-none'); }
      }
      function picked(doc) {
        return Array.prototype.map.call(doc.querySelectorAll('[data-pd-option]'), function (s) {
          var o = s.querySelector('option[selected]') || s.querySelector('option');
          return o ? o.getAttribute('value') : '';
        });
      }
      function remote() {
        var ids = selects.map(function (s) { var o = s.options[s.selectedIndex]; return o ? o.getAttribute('data-id') : ''; });
        var url = root.getAttribute('data-url'), sec = root.getAttribute('data-section');
        if (!window.fetch || !window.DOMParser || !url || !sec || ids.some(function (x) { return !x; })) { none(); return; }
        var want = selects.map(function (s) { return s.value; });
        var my = ++seq;
        if (addBtn) addBtn.disabled = true;
        fetch(url + '?section_id=' + encodeURIComponent(sec) + '&option_values=' + ids.join(','))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (my !== seq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var idEl = doc.querySelector('[data-pd-variant-id]'), pEl = doc.querySelector('[data-pd-price]'), aEl = doc.querySelector('[data-pd-add]');
            if (!idEl || !pEl || picked(doc).join('|') !== want.join('|')) { none(); return; }
            var v = { id: parseInt(idEl.value, 10), o: want, p: parseInt(pEl.getAttribute('data-pd-price'), 10), a: !!(aEl && !aEl.hasAttribute('disabled')) };
            if (!moneyMap[v.p]) moneyMap[v.p] = pEl.innerHTML;
            variants.push(v);
            apply(v);
          })
          .catch(function () { if (my === seq) none(); });
      }

      function update() {
        var v = find();
        if (!v) {
          if (variants.length < total) { remote(); return; }
          none();
          return;
        }
        seq++;
        apply(v);
      }

      function apply(v) {
        if (idInput) idInput.value = v.id;
        var sp = document.querySelector('[data-pd-sticky-price]');
        if (priceEl && v.p !== shownPrice) {
          priceEl.innerHTML = moneyMap[v.p] || money(v.p);
          shownPrice = v.p;
        }
        if (sp && priceEl) sp.innerHTML = priceEl.innerHTML;
        if (addBtn) {
          addBtn.disabled = !v.a;
          addBtn.textContent = v.a ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });

    /* Gallery: the main image is a track that swipes sideways, one photo per
       screen. Thumbnails jump to a photo, the arrows step, the counter and the
       marked thumbnail follow whatever is on screen. */
    document.querySelectorAll('[data-gal]').forEach(function (gal) {
      var track = gal.querySelector('[data-gal-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gal-slide]'));
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-to]'));
      var strip = gal.querySelector('.gal__ts');
      var count = gal.querySelector('[data-gal-count]');
      var n = slides.length;
      if (n < 2) return;
      function index() {
        return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / track.clientWidth)));
      }
      function go(i) {
        i = Math.max(0, Math.min(n - 1, i));
        warm(i);
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        /* If the smooth scroll is cut short (throttled tab, reduced motion), land anyway. */
        setTimeout(function () {
          if (index() !== i) track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
        }, 700);
      }
      /* The photo on screen and its two neighbours load now, the rest stay lazy. */
      function warm(i) {
        [i - 1, i, i + 1].forEach(function (k) {
          var img = slides[k] && slides[k].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }
      function mark() {
        var i = index();
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + n;
        var on = thumbs[i];
        if (on && strip) {
          var left = on.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft || left + on.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({ left: left - 10, behavior: 'smooth' });
          }
        }
        warm(i);
      }
      track.addEventListener('scroll', mark, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = gal.querySelector('[data-gal-prev]');
      var next = gal.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      });
      mark();
    });

    /* Related products come from Shopify's recommendations endpoint. */
    document.querySelectorAll('[data-pd-related]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var inner = d.querySelector('[data-pd-related]');
        if (inner && inner.querySelector('.card')) {
          el.innerHTML = inner.innerHTML;
          el.removeAttribute('hidden');
        }
      }).catch(function () {});
    });
  }

  /* ---------- collection filters ---------- */
  /* The markup already works with JavaScript off: chips are ordinary links to
     Shopify tag paths and the rest is a GET form. This only swaps the section
     in place instead of reloading the page, and keeps the panel open while the
     shopper narrows down. Everything is delegated from the document, so the
     swapped in markup needs no rebinding. */
  function filters() {
    var SEL = '[data-pd-coll]';
    if (!document.querySelector(SEL)) return;

    function root() { return document.querySelector(SEL); }

    function panel() {
      var r = root();
      return r ? r.querySelector('[data-f-panel]') : null;
    }

    function isOpen() {
      var p = panel();
      return !!p && !p.hidden;
    }

    function setOpen(open) {
      var p = panel();
      if (!p) return;
      p.hidden = !open;
      var b = root().querySelector('[data-f-toggle]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function load(url, push) {
      var r = root();
      if (!r) return;
      var open = isOpen();
      var id = r.getAttribute('data-section-id');
      r.classList.add('is-busy');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var fresh = d.querySelector(SEL);
          if (!fresh) { window.location.href = url; return; }
          r.innerHTML = fresh.innerHTML;
          r.classList.remove('is-busy');
          if (open) setOpen(true);
          if (push) window.history.pushState({ pd: 1 }, '', url);
          var top = r.getBoundingClientRect().top;
          if (top < -8) window.scrollTo(0, window.pageYOffset + top - 10);
        })
        .catch(function () { window.location.href = url; });
    }

    /* Serialise the form the way the browser would, minus the empty fields, so
       a blank price box does not end up in the URL. */
    function formUrl(form) {
      var out = [];
      new FormData(form).forEach(function (v, k) {
        v = String(v).trim();
        if (v !== '') out.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
      var action = form.getAttribute('action') || window.location.pathname;
      return action + (out.length ? '?' + out.join('&') : '');
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-f-toggle]')) { setOpen(!isOpen()); return; }

      if (t.closest('[data-f-done]')) { e.preventDefault(); setOpen(false); return; }

      var link = t.closest('[data-f-link]') || t.closest('[data-pd-coll] .pgn a');
      if (link && link.href && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        load(link.href, true);
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      var form = e.target.closest('[data-f-form]');
      if (form) load(formUrl(form), true);
    });

    window.addEventListener('popstate', function () { load(window.location.href, false); });
  }

  /* ---------- cart: quantity changes submit the form ---------- */
  function cart() {
    var form = document.getElementById('pd-cart');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-pd-qty]')) form.submit();
    });
  }

  ready(function () { drawer(); product(); filters(); cart(); });
})();
